import React, { FC, Fragment } from 'react';
import {
  ClHeaderDesktop,
  ClHeaderMobile,
} from 'components/clientComp/clHeader/components';
import { useWindowSize } from 'shared/helpers/useWindowSize';

import './ClHeader.scss';

const ClHeader: FC = () => {
  const currentWidth = useWindowSize();
  return (
    <Fragment>
      {currentWidth <= 1023 ? <ClHeaderMobile /> : <ClHeaderDesktop />}
    </Fragment>
  );
};

export default ClHeader;
